import { t } from "i18next";
import React from "react";

import "./SportBonusPage.scss";

const SportBonusPage = () => {
  return (
    <div
      className="sportBonusWrapper-bc casinoBonus_ProgressBar"
      data-scroll-lock-scrollable=""
    >
      <p className="empty-b-text-v-bc">
        {t("admin.Therearenobonusesforselectedtype")}
      </p>
    </div>
  );
};

export { SportBonusPage };
